import { NgModule } from '@angular/core';
import { RenewSubscriptionMessageComponent } from './renew-subscription-message.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [RenewSubscriptionMessageComponent],
    imports: [
        CommonModule
    ],
    exports: [RenewSubscriptionMessageComponent]
})
export class RenewSubscriptionModule {
}
